import { createSelector } from '@reduxjs/toolkit';

import type { SliceStateFromReducer } from 'shared/types';

import type { pledgeAutoFormSlice } from 'entities/pledgeAutoForm';

export type TPledgeAutoState = SliceStateFromReducer<typeof pledgeAutoFormSlice>;

export const selectPledgeFormInfo = (state: TPledgeAutoState) => state.pledgeAutoForm;

export const selectDefaultPledgeAutoData = (state: TPledgeAutoState) => {
  return state.pledgeAutoForm.defaults;
};

export const selectPledgeAutoData = (state: TPledgeAutoState) => {
  if (!state.pledgeAutoForm.data) {
    return state.pledgeAutoForm.defaults;
  }

  return state.pledgeAutoForm.data;
};

export const selectIsPledgeAutoFormFullFilled = createSelector(selectPledgeFormInfo, (state) => state.isFullFilled);
export const selectVehicleType = createSelector(selectPledgeFormInfo, (data) => data?.vehicleType ?? 'car');

export const selectCarInfoDictionaries = (state: TPledgeAutoState) => state.pledgeAutoForm.dictionaries;
export const selectIsCarInfoLoadedSuccessfully = (state: TPledgeAutoState) =>
  state.pledgeAutoForm.carInfoStatus === 'success';
export const selectIsCarInfoEmpty = (state: TPledgeAutoState) => state.pledgeAutoForm.carInfoStatus === 'empty';
export const selectIsCarInfoLoading = (state: TPledgeAutoState) => state.pledgeAutoForm.carInfoStatus === 'loading';
export const selectIsCarInfoLoadingError = (state: TPledgeAutoState) => state.pledgeAutoForm.carInfoStatus === 'error';
export const selectIsCarInfoLoadingInitialSate = (state: TPledgeAutoState) =>
  state.pledgeAutoForm.carInfoStatus === 'initial';
